import { useTranslation } from "@impero-com/common/utils/i18n";
import { TableToolbar, TextTool } from "@impero-com/ui";
import { useOutletContext } from "react-router-dom";

import { AssignmentTable } from "org/user/components/AssignmentTable";
import { ReplaceUserModal } from "org/user/components/ReplaceUserModal";
import { usePushReportsResponsibleForUserQuery } from "org/user/queries/usePushReportsResponsibleForUserQuery";
import { OutletContext } from "org/user/UserViewPage";
import { getFilterModeConfig } from "utils/table/getFilterModeConfig";

import { useReplacePushReportResponsibleUtils } from "./useReplacePushReportResponsibleUtils";
import {
    PushReportResponsibleRow,
    useUserPushReportsResponsibleListTable,
} from "./useUserPushReportsResponsibleListTable";

export function UserPushReportsResponsibleList() {
    const { user } = useOutletContext<OutletContext>();
    const userId = user.id;
    const { data } = usePushReportsResponsibleForUserQuery(userId);
    const { t } = useTranslation();
    const { table, tableId, getFilterComponent } =
        useUserPushReportsResponsibleListTable(data);
    const selectedRows = table.getFilteredSelectedRowModel().rows;
    const deselectAll = () => table.resetRowSelection();

    const {
        replaceUserToolState,
        isReplaceUserModalOpen,
        openReplaceUserModal,
        closeReplaceUserModal,
        replaceUser,
        isReplacingUser,
    } = useReplacePushReportResponsibleUtils({
        userId,
        selectedRows,
        deselectAll,
    });

    return (
        <div>
            <ReplaceUserModal
                open={isReplaceUserModalOpen}
                replaceType="WithUser"
                loading={isReplacingUser}
                onClose={closeReplaceUserModal}
                onClick={(userOrGroup) => void replaceUser(userOrGroup)}
                user={user}
            />
            <AssignmentTable<PushReportResponsibleRow>
                table={table}
                tableId={tableId}
                getFilterComponent={getFilterComponent}
                modeConfig={getFilterModeConfig(t)}
                toolbar={
                    <TableToolbar>
                        <TextTool
                            state={replaceUserToolState}
                            onClick={openReplaceUserModal}
                        >
                            {t("AccessAndAssignment_Tool_ReplaceUser")}
                        </TextTool>
                    </TableToolbar>
                }
            />
        </div>
    );
}
